import { css } from '@emotion/css';

export const dialogTextCss = css`
  padding-top: 16px;
  text-align: center;
`;

export const actionButtonCss = css`
  margin-top: 16px !important;
  text-transform: none !important;
`;
